import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import { AppBreakGuard } from './shared/guards/appBreak.guard';
import { CrmModuleGuard } from './shared/guards/crm-module.guard';
import { SignedInLayoutComponent } from './view/user-context/components/signed-in-layout/signed-in-layout.component';
import { SignInComponent } from './view/user-context/pages/sign-in/sign-in.component';
import { ActionHandlerComponent } from './view/user-context/pages/action-handler/action-handler.component';
import { AccessPendingComponent } from './view/user-context/pages/access-pending/access-pending.component';
import { EstateQrPageComponent } from './view/user-context/pages/estate-qr-page/estate-qr-page.component';
import { PublicDefectStatusPageComponent } from './view/user-context/pages/public-defect-status-page/public-defect-status-page.component';
import { SignedInStartRedirectComponent } from './view/user-context/components/signed-in-start-redirect/signed-in-start-redirect.component';
import { ContextResolver } from './view/user-context/services/context.resolver';

const routes: Routes = [
  {
    path: 'signIn',
    component: SignInComponent
  },
  {
    path: 'actions',
    component: ActionHandlerComponent
  },
  {
    path: 'access',
    component: AccessPendingComponent
  },
  {
    path: 'qr/estate',
    component: EstateQrPageComponent
  },
  {
    path: 'defect/report',
    component: EstateQrPageComponent
  },
  {
    path: 'defect/status',
    component: PublicDefectStatusPageComponent
  },
  {
    path: '',
    pathMatch: 'full',
    component: SignedInStartRedirectComponent,
    canActivate: [AuthGuard, AppBreakGuard]
  },
  {
    path: 'offers',
    loadChildren: () => import('./view/offers/offers.module').then((m) => m.OffersModule),
    canActivate: [AuthGuard, AppBreakGuard],
    canActivateChild: [AuthGuard, AppBreakGuard]
  },
  {
    path: '',
    canActivate: [AuthGuard, AppBreakGuard, CrmModuleGuard],
    canActivateChild: [AuthGuard, AppBreakGuard, CrmModuleGuard],
    resolve: { context: ContextResolver },
    children: [
      {
        path: '',
        component: SignedInLayoutComponent,
        // prettier-ignore
        children: [
          { path: 'dashboard',   loadChildren: () => import('./view/dashboard/dashboard.module'     ).then((m) => m.DashboardModule   ) },
          { path: 'messages',    loadChildren: () => import('./view/messaging/messaging.module'     ).then((m) => m.MessagingModule   ) },
          { path: 'resolutions', loadChildren: () => import('./view/resolutions/resolution.module'  ).then((m) => m.ResolutionModule  ) },
          { path: 'reckonings',  loadChildren: () => import('./view/reckonings/reckonings.module'   ).then((m) => m.ReckoningsModule  ) },
          { path: 'news',        loadChildren: () => import('./view/news/news.module'               ).then((m) => m.NewsModule        ) },
          { path: 'booking',     loadChildren: () => import('./view/booking/booking.module'         ).then((m) => m.BookingModule     ) },
          { path: 'defects',     loadChildren: () => import('./view/defects/defects.module'         ).then((m) => m.DefectsModule     ) },
          { path: 'concierge',   loadChildren: () => import('./view/concierge/concierge.module'     ).then((m) => m.ConciergeModule   ) },
          { path: 'polls',       loadChildren: () => import('./view/poll/poll.module'               ).then((m) => m.PollModule        ) },
          { path: 'connections', loadChildren: () => import('./view/connections/connections.module' ).then((m) => m.ConnectionsModule ) },
          { path: 'users',       loadChildren: () => import('./view/users/users.module'             ).then((m) => m.UsersModule       ) },
          { path: 'estate',      loadChildren: () => import('./view/estate-view/estate.module'      ).then((m) => m.EstateModule      ) },
          { path: 'calendar',    loadChildren: () => import('./view/calendar/calendar.module'       ).then((m) => m.CalendarModule    ) },
          { path: 'event-log',   loadChildren: () => import('./view/event-log/event-log.module'     ).then((m) => m.EventLogModule    ) },
          { path: 'reports',     loadChildren: () => import('./view/reports/reports.module'         ).then((m) => m.ReportsModule     ) },
          { path: 'websites',    loadChildren: () => import('./view/websites/websites.module'       ).then((m) => m.WebsitesModule    ) },
          { path: 'offers',      loadChildren: () => import('./view/offers/offers.module'           ).then((m) => m.OffersModule      ) },
          { path: 'help',        loadChildren: () => import('./view/help/help.module'               ).then((m) => m.HelpModule        ) },
          { path: 'admin',       loadChildren: () => import('./view/admin/admin.module'             ).then((m) => m.AdminModule       ) },
          { path: 'settings',    loadChildren: () => import('./view/settings/settings.module'       ).then((m) => m.SettingsModule    ) },
          { path: 'company',     loadChildren: () => import('./view-company/view-company.module'    ).then((m) => m.ViewCompanyModule ) },
          { path: 'bluebolt',    loadChildren: () => import('./view/bluebolt/bluebolt.module'       ).then((m) => m.BlueboltModule    ) },
          { path: '**',          redirectTo: 'dashboard' }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
